// TSS vite/04 §"Endpoint paths".
// URL knowledge lives here: a backend rename touches one file.
//
// No leading slash, on purpose. `api` has baseURL http://<host>/api/v1 and
// axios joins baseURL + url with a single slash; a leading slash here would
// produce .../api/v1//admin/clients.

export const clientPaths = {
    list:   ()   => 'admin/clients',
    detail: (id) => `admin/clients/${id}`,
};

// GET /admin/clients/{id} answers in parts. The base and `projects_summary`
// always travel; the project list only with ?include=projects. Parts are asked
// for BY NAME — a numbered level would change meaning the day a new one is
// inserted in the middle (api-reference.md, Organización).
//
// Nothing asks for the projects yet. The helper exists so that whoever needs
// them adds `{ include: 'projects' }` here instead of hand-writing a query
// string at the call site.
export function clientDetailParams({ include } = {}) {
    return include ? { include } : undefined;
}
